<div class="container-fluid p-0">
  <div class="container bg-max">
    <div class="d-flex justify-content-end mb-2 gap-2" *ngIf="editInitail && certType == 3">
      <button class="v4-btn-every py-2" *ngIf="editFlag" (click)="handlePreview(false)">
        {{ "Preview" | translator }}
      </button>
      <button class="v4-btn-every py-2" *ngIf="!editFlag && assessmentId == ''" (click)="handlePreview(true); description = undefined">
        {{ "Certificate Save" | translator }}
      </button>
    </div>
    <div class="d-flex justify-content-center my-2" *ngIf="userTesting">
      <button class="v4-btn-every py-2 m-1" *ngFor="let criteria of percentageCriteria" (click)="changeGrade(criteria.to - 1)" >
        {{ criteria.title }}
      </button>
    </div>
    <div #certificateElement *ngIf="!loader" class="w-100 p-4 bg-white">
      <div>
        <img *ngIf="certType == 1 || certType == 3" class="w-320px mb-3"
         src="../../../assets/sbccolorlogo-01.png" alt="loading" />
        <span *ngIf="certType == 3" class="p-black" [innerHTML]="description"></span>
        <!-- <h1 class="txt-clr mt-5">Congratulations</h1>
        <h5 class="txt-clr my-5">This is to certify that<span class="blue-italic">Muhammad Sufyan</span>has completed the
        training<span class="blue-italic">Artificial Intelligence</span>and has passed all the assessments. we wish him
        best of luck.</h5> -->

        <div *ngIf="editFlag && certType == 3" class="mb-4">
          <p-editor [(ngModel)]="certificateDate.description" [required]="true" id="description"
            [style]="{ height: '180px' }">
          </p-editor>
        </div>
        
        <!-- NEW certificate code START -->
        <div *ngIf="certType == 1" class="d-flex">
          <div class="d-flex purp pos-rel">
            <div class="pos-abs-certificate-1">{{ translate('Shahadat') }}</div>
            <div class="pos-abs-certificate-2">{{ translate('Hazoor') }}</div>
            <div class="bg-img-certi">
            </div>
          </div>
          <div class="gr">
            <div class="text-alignment"
              [innerHTML]=" (currentSession?.certTopText) ? formatAttendaceCertificate(currentSession?.certTopText) : formatAttendaceCertificate(translate('DefaultCertAttendanceTop'))"
            >
            </div>
            <div class="d-flex my-4">
              <div class="white-input" [innerHTML]=" (currentSession?.certMiddleText) ? formatAttendaceCertificate(currentSession?.certMiddleText) : formatAttendaceCertificate(translate('DefaultCertAttendanceMiddle'))"></div>
              <div class="img-box">
                <img class="certi-img" src="../../../assets/bg/certificate/arrow.png" alt="loading">
              </div>
            </div>
            <div class="Details" [innerHTML]=" (currentSession?.certBottom1Text) ? formatAttendaceCertificate(currentSession?.certBottom1Text) : formatAttendaceCertificate(translate('DefaultCertAttendanceBottom'))">
            </div>
            <div class="Details-heading" [innerHTML]=" (currentSession?.certBottom2Text) ? formatAttendaceCertificate(currentSession?.certBottom2Text) : formatAttendaceCertificate(translate('DefaultCertAttendanceBottom2'))">
            </div>
            <div>
              <div class="row mt-5">
                <div class="col-md-6 col-12 flex-column">
                  <div *ngIf="currentSession?.logo_img" class="signature">
                    <img class="sign" [src]=" (currentSession?.logo_img) ? currentSession?.logo_img : '../../../assets/vision2030.png'" alt="loading">
                  </div>
                  <div *ngIf="currentSession?.partnerName" class="bottom-Details">
                    {{ (currentSession?.partnerName) ? currentSession?.partnerName : this.translate('DefaultPartnerName') }}
                  </div>
                </div>
                <div class="col-md-6 col-12 flex-column">
                  <div class="bottom-Details" [innerHTML]=" (currentSession?.certBottom3Text) ? formatAttendaceCertificate(currentSession?.certBottom3Text) : formatAttendaceCertificate(translate('DefaultCertAttendanceBottom3'))">
                  </div>
                  <div class="signature">
                    <img class="sign" [src]=" (currentSession?.sign_image) ? currentSession?.sign_image : '../../../assets/signature.png'" alt="loading">
                  </div>
                  <div class="big-Details">
                    {{ (currentSession?.managerName) ? currentSession?.managerName : this.translate('DefaultManagerName') }}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!-- NEW certificate code END -->

        <!-- certificate START -->
        <div *ngIf="certType == 2 && hasMinistry == false" class="container-fluid">
          <div class="container bg-immmg">
            <div class="row bg-immg">
              <div class="col-md-9 col-12">
                <div class="box-adjustment">
                  <h3 class="blue-text" [innerHTML]=" (gradeData?.certificateText?.top) ? formatAssessmentName(gradeData?.certificateText?.top) : formatAssessmentName(this.translate('DefaultCertificateTop')) ">
                  </h3>
                  <h3 class="C-font-ui" [innerHTML]="(gradeData?.certificateText?.middle) ? formatAssessmentName(gradeData?.certificateText?.middle) : formatAssessmentName(this.translate('DefaultCertificateMiddle'))">
                  </h3>
                  <div class="main-name-adjust">
                    <h1 class="name-ui">
                      {{ gradeData?.title }}
                    </h1>
                    <h3 class="name-ui-mini">معدل %{{ userScore }}</h3>
                  </div>
                  <h3 class="C-font-ui" [innerHTML]="(gradeData?.certificateText?.bottom) ? formatAssessmentName(gradeData?.certificateText?.bottom) : formatAssessmentName(this.translate('DefaultCertificateBottom'))">
                  </h3>
                </div>
                <div class="logo-adustment">
                  <img class="" src="../../../assets/logo.png" alt="loading">
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="pos-rel">
                  <img class="badge-ui" [src]="'../../../assets/bg/certificate/' + ((gradeData?.icon) ? gradeData?.icon : 'Badge2.png') " alt="loading">
                  <img class="logo-stand" src="../../../assets/bg/certificate/sidepurppleelement.png" alt="loading">
                  <div class="footer-ui">
                    <p class="footer-text">الإدارة العامة للشراكات وتطوير القدرات</p>
                    <p class="footer-mini flex-column">تواصل معنا: <a class="footer-text"
                        href="mailto:Pdc@bc.gov.sa">{{ 'Pdc@bc.gov.sa' }}</a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- certificate END -->

        <!-- certificate START assessment 2  -->
        <div *ngIf="certType == 2 && hasMinistry == true" class="container-fluid">
          <div class="container">
            <div class="logo-adustment-2">
              <img class="" src="../../../assets/logo.png" alt="loading">
            </div>
            <div class="bg-grey-2">
              <div class="pos-rel-2 d-flex justify-content-center">
                <div class="pos-abs-2">
                  <img style="width:180px;" [src]="'../../../assets/bg/certificate/' + ((gradeData?.icon) ? gradeData?.icon : 'Badge2.png')" alt="loading">
                </div>
              </div>
              <div class="main-name-adjust-2">
                <h1 class="name-ui-2">{{ gradeData?.title }}</h1>
                <h3 class="name-ui-mini-2">معدل %{{ userScore }}</h3>
              </div>
              <div class="bg-blue" 
                [innerHTML]=" (assessmentData?.certificateMinistry?.text1) ? formatAssessmentName(assessmentData?.certificateMinistry?.text1) : formatAssessmentName(this.translate('DefaultCertMinistryText1')) "
              >
              </div>
              <div class="d-flex">
                <div class="forty-percent">
                  الاسم
                </div>
                <div class="sixty-percent">
                  {{ userData.name }}
                </div>
              </div>
              <div class="d-flex">
                <div class="forty-percent">
                  الدرجة من {{ (assessmentResultData?.totalmarks) ? assessmentResultData?.totalmarks : 25 }}
                </div>
                <div class="sixty-percent">
                  {{ (assessmentResultData?.score) ? assessmentResultData?.score : 20 }}
                </div>
              </div>
              <div class="only-borders" *ngIf="inCorrectMinistry != undefined && inCorrectMinistry.length > 0">
                <h3 class="border-texts"
                  [innerHTML]=" (assessmentData?.certificateMinistry?.text2) ? formatAssessmentName(assessmentData?.certificateMinistry?.text2) : formatAssessmentName(this.translate('DefaultCertMinistryText2')) "
                >
                </h3>
                <div class="scroll-imgs" >
                  <ng-container *ngFor="let ministry of inCorrectMinistry">
                    <img class="scroll-inner-imgs" src="{{ staticFileUrl + ministry?.icon }}" [alt]="ministry.label">
                  </ng-container>
                </div>
              </div>
              <div class="bg-blue mb-4" *ngIf="inCorrectMinistry != undefined && inCorrectMinistry.length > 0"
                [innerHTML]=" (assessmentData?.certificateMinistry?.text3) ? formatAssessmentName(assessmentData?.certificateMinistry?.text3) : formatAssessmentName(this.translate('DefaultCertMinistryText3')) "
              >
              </div>
              <p-chart
                *ngIf="inCorrectMinistry != undefined && inCorrectMinistry.length > 0"
                type="bar"
                [data]="graphData"
                [options]="barChartOptions"
                height="400"
              ></p-chart>
              <div class="only-borders" *ngIf="correctMinistry != undefined && correctMinistry.length > 0">
                <div class="pos-rel-2">
                  <img class="star-2" src="../../../assets/bg/certificate/star.png" alt="loading...">
                </div>  
                <h3 class="border-texts"
                  [innerHTML]=" (assessmentData?.certificateMinistry?.text4) ? formatAssessmentName(assessmentData?.certificateMinistry?.text4) : formatAssessmentName(this.translate('DefaultCertMinistryText4')) "
                >
                </h3>
                <div class="scroll-imgs-2" >
                  <ng-container *ngFor="let ministry of correctMinistry">
                    <img class="scroll-inner-imgs" src="{{ staticFileUrl + ministry?.icon }}" [alt]="ministry.label">
                  </ng-container>
                </div>
              </div>
            </div>
            <h3 class="C-font-ui-2"
              [innerHTML]=" (assessmentData?.certificateMinistry?.text5) ? formatAssessmentName(assessmentData?.certificateMinistry?.text5) : formatAssessmentName(this.translate('DefaultCertMinistryText5')) "
            >
            </h3>
            <div class="footer-2 py-4">
              <h5 class="footer-mx">عام 2024</h5>
              <div class="pos-rel-2">
                <img class="logo-stand-2" src="../../../assets/bg/certificate/sidepurppleelement.png" alt="loading">
                <div class="footer-ui-2">
                  <p class="footer-text-2" >
                    الإدارة العامة للشراكات وتطوير القدرات
                  </p>
                  <br>
                  <p class="footer-mini-2 flex-column-2">تواصل معنا:</p>
                  <a class="footer-text-2" href="mailto:Pdc@bc.gov.sa">{{ 'Pdc@bc.gov.sa' }}</a>
                </div>
              </div>
            </div>      
          </div>
        </div>
        <!-- certificate END assessment 2  -->

      </div>
      <table *ngIf="sessions != undefined && sessions.length > 0 && certType == 3">
        <thead>
          <tr>
            <th *ngIf="editFlag" scope="col"></th>
            <th style="width: 45%" scope="col">
              <i class="fa-solid fa-users color-blue"></i>{{ "SESSION" | translator }}
            </th>
            <th style="width: 35%" scope="col">
              <i class="pi pi-file color-blue"></i>{{ "Type" | translator }}
            </th>
            <th style="width: 20%" scope="col">
              <i class="pi pi-calendar color-blue"></i>{{ "DATES" | translator }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let session of sessions">
            <td data-label="Account" *ngIf="editFlag">
              <div>
                <p-checkbox [(ngModel)]="session.visible" [binary]="true" inputId="binary" />
              </div>
            </td>
            <td style="width: 45%" data-label="Account">
              <div class="border-left">{{ session?.details?.title }}</div>
            </td>
            <td style="width: 20%" data-label="Amount">
              <div class="border-left">
                {{ session?.details?.sessionType | translator }}
              </div>
            </td>
            <td style="width: 35%" data-label="Period">
              <div class="box-w-200">
                <div class="project-name-pg-4">
                  <div class="d-flex justify-content-between mob-my-2-pg-4">
                    <div class="bold ml-10px">
                      {{ "Start Date" | translator }}
                    </div>
                    <div class="d-flex align-items-center mx-2">
                      <i class="full-stop"></i>
                      <div class="time-bar"></div>
                      <i class="pi pi-arrow-left icon-purple"></i>
                    </div>
                    <div class="bold mr-10px">
                      {{ "End Date" | translator }}
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <div>{{ session?.details?.date | date }}</div>
                  <div class="date-bar"></div>
                  <div>{{ session?.details?.date | date }}</div>
                </div>
              </div>
            </td>
          </tr>

        </tbody>
      </table>

      <br />

      <table *ngIf="assessments != undefined && assessments.length > 0 && certType == 3">
        <thead>
          <tr>
            <th *ngIf="editFlag" scope="col"></th>
            <th style="width: 45%" scope="col">
              <i class="fa-solid fa-pen-to-square color-blue"></i>{{ "Assessment" | translator }}
            </th>
            <th style="width: 35%" scope="col">
              <i class="pi pi-percentage color-blue"></i>{{ "Percentage" | translator }}
            </th>
            <th style="width: 20%" scope="col">
              <i class="pi pi-star-fill color-blue"></i>{{ "Grade" | translator }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ass of assessments">
            <td *ngIf="editFlag" data-label="Account">
              <div>
                <p-checkbox [binary]="true" [(ngModel)]="ass.visible" inputId="binary" />
              </div>
            </td>
            <td style="width: 45%; padding: 25px 10px" data-label="Account">
              <div class="border-left">{{ ass.details.title }}</div>
            </td>
            <td style="width: 35%; padding: 25px 10px" data-label="Period">
              <div class="border-left pl-15px">
                <p-progressBar class="certify" [value]="
                    ass?.details?.assessmentResult
                      ? getScore(ass?.details?.assessmentResult[0])
                      : 0
                  " />
              </div>
            </td>
            <td style="width: 20%; padding: 25px 10px" data-label="Amount">
              <div>
                {{ ass?.details?.assessmentResult ? ass?.details?.grade : "-" }}
              </div>
            </td>
          </tr>

          <!-- <tr>
         
          <td style="width: 45%;padding: 25px 10px;" data-label="Account">
            <div class="border-left">كما إحكام أصقاع يونيو.</div>
          </td>
          <td style="width: 35%;padding: 25px 10px;" data-label="Period">
            <div class="border-left pl-15px"><p-progressBar class="certify" [value]="25" /></div>
          </td>
          <td style="width: 20%;padding: 25px 10px;" data-label="Amount">
            <div>Bad</div>
          </td>
        </tr> -->

          <!-- <tr>
          <td data-label="Account">
            <div><p-checkbox [binary]="true" inputId="binary" /></div>
          </td>
          <td style="width: 45%;padding: 25px 10px;" data-label="Account">
            <div class="border-left">كما إحكام أصقاع يونيو.</div>
          </td>
          <td style="width: 35%;padding: 25px 10px;" data-label="Period">
            <div class="border-left pl-15px"><p-progressBar class="certify" [value]="30" /></div>
          </td>
          <td style="width: 20%;padding: 25px 10px;" data-label="Amount">
            <div>Excellent</div>
          </td>
        </tr>

        <tr>
          <td data-label="Account">
            <div><p-checkbox [binary]="true" inputId="binary" /></div>
          </td>
          <td style="width: 45%;padding: 25px 10px;" data-label="Account">
            <div class="border-left">كما إحكام أصقاع يونيو.</div>
          </td>
          <td style="width: 35%;padding: 25px 10px;" data-label="Period">
            <div class="border-left pl-15px"><p-progressBar class="certify" [value]="10" /></div>
          </td>
          <td style="width: 20%;padding: 25px 10px;" data-label="Amount">
            <div>Very Good</div>
          </td>
        </tr> -->
        </tbody>
      </table>
    </div>
  </div>
  <div *ngIf="loader" class="d-flex justify-content-center align-items-center h-500px">
    <p-progressSpinner ariaLabel="{{ 'loading' | translator }}" />
  </div>
  <app-no-data *ngIf="!this.certificateDate"></app-no-data>
  <div class="d-flex justify-content-center my-2">
    <button *ngIf="(!editFlag || certType!= 3) && printFlag == false" class="v4-btn-every py-2 m-1" (click)="printCertificate($event)">
      {{ "Print" | translator }}
    </button>

    <div *ngIf="printFlag" class="d-flex justify-content-center">
      <p-progressSpinner
        width="50%"
      ></p-progressSpinner>
    </div>
  </div>
  <!-- RATTING ADVANCED UI DEVELOPED -->
  <!-- <div class="container">
    <p-table [value]="[0,1,2]" [tableStyle]="{'min-width': '50rem'}">
      <ng-template pTemplate="header">
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Rating</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product>
        <tr>
          <td>{{product.code}}</td>
          <td>Rao Osama</td>
          <td><p-rating class="v4-rate" formControlName="score"></p-rating></td>
        </tr>
      </ng-template>
    </p-table>
  </div> -->
  <!-- RATTING ADVANCED UI DEVELOPED -->
</div>